
import {
  Injectable,
  Inject,
  InjectionToken,
  ErrorHandler,
  Injector
} from '@angular/core';
import Rollbar from '@node_modules/rollbar/replay';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { environment } from 'environments/environment';




const rollbarConfig: Rollbar.Configuration = {
  accessToken: environment.RollbarAccessToken,
  captureUncaught: false,
  captureUnhandledRejections: false,
  environment: environment.RollbarErrorEnviornment,
  payload: {
    code_version: '11.0.0'
  },
  autoInstrument: {
    log: false,               // Disable log instrumentation
    network: true,            // Keep API call tracking (needed for server exceptions)
    networkResponseHeaders: true,
    networkRequestBody: true,
    networkResponseBody: true,
    connectivity: false,
    dom: false,
    navigation: false,
    contentSecurityPolicy: false,
    errorOnContentSecurityPolicy: false
  },
  includeItemsInTelemetry: true,
  uncaughtErrorLevel: 'critical',
  // captureTelemetry: true,
  replay: {
    enabled: environment.enableRollbar,
    autoStart: true,  // IMPORTANT: initialize manually
    inlineStylesheet: true,
    inlineImages: true,
    collectFonts: true,
    maskInputOptions: { password: true },
  },

};


export const RollbarService = new InjectionToken<Rollbar>('rollbar');

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  private _appSessionService: AppSessionService | null = null;
  constructor(@Inject(RollbarService) private rollbar: Rollbar, private injector: Injector) { }

  private get appSessionService(): AppSessionService {
    if (!this._appSessionService) {
      this._appSessionService = this.injector.get(AppSessionService);
    }
    return this._appSessionService;
  }

  handleError(err: any): void {
    const e = err?.originalError || err;

    // Prevent sending invalid errors to Rollbar
    if (!e) {
      return;
    }

    if (e?.isSwaggerException) {
      let parsed: any = null;

      try {
        parsed = JSON.parse(e.response);
        if (parsed?.error?.code == 901) {
          return;

        }
      } catch { }

      // Build user data
      const user = this.appSessionService?.user ?? null;

      // Optional: add any additional exception metadata
      const metadata = {
        url: location.href,
        timestamp: new Date().toISOString(),
        message: e?.message,
        stack: e?.stack,
        swaggerResponse: parsed
      };

      // Ensure Rollbar always gets valid error input
      const errorToSend =
        e instanceof Error ? e : new Error(e?.message || 'Unknown exception');

      // Send extended payload to Rollbar
      this.rollbar.error(errorToSend, { user, metadata });
    }

  }
}

export function rollbarFactory() {
  return new Rollbar(rollbarConfig);
}